import request from '@/utils/request'

// 账号注册
export function register(data) {
  return request({
    url: '/api/user/register',
    method: 'post',
    data
  })
}

// 账号注销
export function cancellation(data) {
  return request({
    url: '/api/user/logoutaccount',
    method: 'post',
    data
  })
}

// 找回密码
export function findPassword(data) {
  return request({
    url: '/api/user/resetpwd',
    method: 'post',
    data
  })
}

// 未成年人注册 user/register18
export function register18(data) {
  return request({
    url: '/api/user/register18',
    method: 'post',
    data
  })
}

// 未成年人注册 user/register14 h5注册
export function register14(data) {
  return request({
    url: '/api/user/register14',
    method: 'post',
    data
  })
}
